// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Ap-z","breadcrumbForward":"Bp-z","breadcrumbBack":"Cp-z","selected":"Dp-z"};